import { MpBookmark } from "../common/bookmark.js";
import { mbSocialSharing, socialSharing } from "../common/sharing.js";

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	// All Lives Bookmarks
	const live_follow = new MpBookmark(document.querySelector("#_live_follow"), {
		message: document.querySelector("#_live_follow .tab_label"),
		message_on: "Non seguire",
		message_off: "Segui",
	});

	// Single live bookmark
	for (const el of document.querySelectorAll("._live_follow_single")) {
		new MpBookmark(document.querySelector(`#${el.id}`), {
			message: document.querySelector(`#${el.id} .tab_label`),
			message_on: "Non seguire",
			message_off: "Segui",
		});
	}

	// SOCIAL SHARE
	if (document.querySelector("#social-share")) {
		const x_text = document.querySelector("#social-share .X").dataset.text;
		const fb = new socialSharing(
			document.querySelector("#social-share .facebook"),
			{ kind: "facebook" },
		);
		const x = new socialSharing(document.querySelector("#social-share .X"), {
			kind: "x",
			title: x_text,
			suffix: " via @Multiplayerit",
		});
		const tg = new socialSharing(
			document.querySelector("#social-share .telegram"),
			{ kind: "telegram" },
		);
		const wa = new socialSharing(
			document.querySelector("#social-share .whatsapp"),
			{ kind: "whatsapp" },
		);
	}
	const mb_share = document.querySelector("#_share-mb");
	if (mb_share) {
		mb_share.addEventListener("click", (event) => {
			event.preventDefault();
			mbSocialSharing(mb_share);
		});
	}
});
